import linkifyHtml from "linkify-html";
import Linkify from "linkify-react";
import React from "react";

// Links open in a new tab, and the opened page gets no handle back to this one.
export const LINK_OPTIONS = {
    target: "_blank",
    rel: "noopener noreferrer",
};

type Props = {
    text?: string | null;
};

// Read-only text with any URLs in it turned into links.
export default function LinkifiedText({ text }: Props) {
    if (!text) return null;
    return <Linkify options={LINK_OPTIONS}>{text}</Linkify>;
}

// Read-only HTML (request/response from the rich text editor) with any URLs in its text turned
// into links. Links already in the HTML are left as they are.
export function LinkifiedHtml({ html, className, style }: { html?: string | null; className?: string; style?: React.CSSProperties }) {
    if (!html) return null;
    return <div className={className} style={style} dangerouslySetInnerHTML={{ __html: linkifyHtml(html, LINK_OPTIONS) }} />;
}
